"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NUMBER = "number";
function debounce(fn, wait) {
    var timer;
    // tslint:disable-next-line
    return function () {
        var args = Array.prototype.slice.call(arguments);
        clearTimeout(timer);
        // @ts-ignore
        timer = setTimeout.apply(void 0, [fn, wait].concat(args));
    };
}
exports.debounce = debounce;
function clampValue(value, _a) {
    var min = _a[0], max = _a[1];
    return Math.min(Math.max(min, value), max);
}
exports.clampValue = clampValue;
function isDefined(predicate) {
    return typeof predicate !== "undefined";
}
exports.isDefined = isDefined;
function requestAnimationTimeout(callback, delay) {
    var start;
    Promise.resolve().then(function () {
        start = Date.now();
    });
    var timeout = function () {
        if (Date.now() - start >= delay) {
            callback.call();
        }
        else {
            frame.id = window.requestAnimationFrame(timeout);
        }
    };
    var frame = {
        id: window.requestAnimationFrame(timeout),
    };
    return frame;
}
exports.requestAnimationTimeout = requestAnimationTimeout;
function cancelAnimationTimeout(frame) {
    window.cancelAnimationFrame(frame.id);
}
exports.cancelAnimationTimeout = cancelAnimationTimeout;
function createAnimationFrameScheduler() {
    var queuedCallback;
    return function (callback) {
        if (!queuedCallback) {
            window.requestAnimationFrame(function () {
                queuedCallback();
                queuedCallback = null;
            });
        }
        queuedCallback = callback;
    };
}
exports.createAnimationFrameScheduler = createAnimationFrameScheduler;
function isNumber(predicate) {
    return typeof predicate === NUMBER && !isNaN(predicate);
}
exports.isNumber = isNumber;
function px(value) {
    return isNumber(value) ? value + "px" : value;
}
exports.px = px;
function memoize(hashFn) {
    if (hashFn === void 0) { hashFn = function (args) { return args.map(function (arg) { return String(arg); }).join("_"); }; }
    return function (target, propertyKey, descriptor) {
        var method = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (!descriptor.value.__cache) {
                descriptor.value.__cache = {};
            }
            var hash = hashFn(args);
            if (!descriptor.value.__cache[hash]) {
                descriptor.value.__cache[hash] = method.apply(this, args);
            }
            return descriptor.value.__cache[hash];
        };
        return descriptor;
    };
}
exports.memoize = memoize;
